export default __webpack_public_path__ + "static/media/RDM_06.72a4b1a1.gif";